export interface LeftArrowProps {
  width?: string;
  height?: string;
}

export function LeftArrow({ width = '24', height = '24', ...rest }: LeftArrowProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      {...rest}
    >
      <path
        d='M10.828 12L15.778 16.95L14.364 18.364L8 12L14.364 5.63599L15.778 7.04999L10.828 12Z'
        fill='#1D2B39'
      />
    </svg>
  );
}
